import React, { useState } from 'react';
import SHA256 from 'crypto-js/sha256';

const BlockSimulator = () => {
  const [blockNumber, setBlockNumber] = useState(1);
  const [difficulty, setDifficulty] = useState(1);
  const [data, setData] = useState('');
  const [nonce, setNonce] = useState(0);
  const [hash, setHash] = useState('');
  const [timestamp, setTimestamp] = useState('');

  const computeHash = (blkNum, nonceVal, blockData) => {
    return SHA256(`${blkNum}${nonceVal}${blockData}`).toString();
  };

  const mineBlock = () => {
    let localNonce = 0;
    let newHash = computeHash(blockNumber, localNonce, data);
    const targetPrefix = '0'.repeat(difficulty);
    while (!newHash.startsWith(targetPrefix)) {
      localNonce++;
      newHash = computeHash(blockNumber, localNonce, data);
    }
    setNonce(localNonce);
    setHash(newHash);
    setTimestamp(new Date().toLocaleString());
  };

  const containerStyle = {
    width: '80%',
    margin: '40px auto',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '10px',
    border: '1px solid #ddd',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#333',
    textAlign: 'left',
    marginTop:'5%'
  };

  const titleStyle = {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '30px',
    color: '#222'
  };

  const rowStyle = {
    display: 'grid',
    gridTemplateColumns: '140px 1fr',
    alignItems: 'center',
    marginBottom: '15px',
    gap: '10px'
  };

  const labelStyle = {
    fontWeight: '600',
    fontSize: '1rem',
    color: '#444'
  };

  const inputStyle = {
    width: '100%',
    padding: '8px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    boxSizing: 'border-box',
    fontFamily: 'Segoe UI, sans-serif'
  };

  const cardStyle = {
    border: '1px solid #ccc',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
  };

  const buttonStyle = {
    padding: '12px 24px',
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    display: 'block',
    margin: '0 auto'
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>Simulador de Bloque</h2>

      <div style={rowStyle}>
        <label style={labelStyle}>Dificultad</label>
        <input
          type="number"
          value={difficulty}
          min="0"
          onChange={(e) => setDifficulty(Math.max(0, Number(e.target.value)))}
          style={inputStyle}
        />
      </div>

      <div style={cardStyle}>
        <div style={rowStyle}>
          <label style={labelStyle}>Bloque #</label>
          <input
            type="number"
            value={blockNumber}
            onChange={(e) => setBlockNumber(Number(e.target.value))}
            style={inputStyle}
          />
        </div>

        <div style={rowStyle}>
          <label style={labelStyle}>Datos</label>
          <textarea
            rows="4"
            value={data}
            onChange={(e) => setData(e.target.value)}
            style={{ ...inputStyle, resize: 'vertical' }}
          />
        </div>

        <div style={rowStyle}>
          <label style={labelStyle}>Nonce</label>
          <input
            type="number"
            value={nonce}
            readOnly
            style={inputStyle}
          />
        </div>

        <div style={rowStyle}>
          <label style={labelStyle}>Hash</label>
          <input
            type="text"
            value={hash}
            readOnly
            style={inputStyle}
          />
        </div>

        <div style={rowStyle}>
          <label style={labelStyle}>Marca de tiempo</label>
          <input
            type="text"
            value={timestamp}
            readOnly
            style={inputStyle}
          />
        </div>
      </div>

      <button onClick={mineBlock} style={buttonStyle}>
        Minar
      </button>
    </div>
  );
};

export default BlockSimulator;
